import { Box, Typography, useMediaQuery } from "@mui/material"
import ReactPlayer from "react-player";
import { Trans, useTranslation } from "react-i18next";

import videoURL from '../../../../assets/videos/bannerVideo.webm'
import TransMsg from '../../transMessage'
import MobileBannerImg from '../../../../assets/images/other/banner_mobile.png'
import {theme} from "../../../../utils";
import {styles} from './homeBanner-helpers'

export const HomeBanner = () => {
    const { t } = useTranslation();

    const isMobileX = useMediaQuery(theme.breakpoints.down(700))
    return (
        <Box sx={styles.bannerWrapper} textAlign={"left"}>
            <Box flex={1} display={"flex"} flexWrap={"wrap"} gap={"10px"}>
                <Box sx={{ mr: "31px", mt:"55px" }}>
                    <Typography sx={[styles.bannerDescription, { fontWeight: 600 }]}>
                        <Trans
                            i18nKey={(t(TransMsg.BANNER_TITLE))}
                            components={{ br: <br /> }} />
                    </Typography>
                    <Typography sx={styles.bannerTitle}>
                        <Trans
                            i18nKey={(t(TransMsg.BANNER_SUB_TITLE))}
                            components={{ br: <br /> }} />
                    </Typography>
                    <Typography sx={[styles.bannerDescription, { marginTop: "29.86px", maxWidth:'650px'}]}>
                        <Trans
                            i18nKey={(t(TransMsg.BANNER_DESC))}
                            components={{ br: <br />, bold: <strong style={{ fontWeight: "600" }} /> }} />
                    </Typography>
                </Box>
                <Box>
                    <Box sx={{ maxWidth: "466px", maxHeight: "380px", position: "relative", overflow: "hidden" }}>
                        {isMobileX ?
                            <img src={MobileBannerImg} style={{ height: "450px", width: "350px", marginLeft: "30px" ,marginTop:"20px"}} alt="Mobile-Banner-Img" />
                            :
                            <>
                                <ReactPlayer
                                    url={videoURL}
                                    controls={false}
                                    loop
                                    playing
                                    playsinline
                                    muted
                                    width={"100%"}
                                    height={"100%"}
                                    style={{ objectFit: "cover" }}
                                />
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "60%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "400px",
                                        height: "400px",
                                        backgroundColor: "#C7D8E5",
                                        borderRadius: "50%",
                                        mixBlendMode: "color",
                                        pointerEvents: "none"
                                    }}
                                />
                            </>
                        }
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
